import React, { FC, useCallback } from 'react'
import FormGroup from '@mui/material/FormGroup'
import TagCheckbox from './TagCheckbox'

import {
  GenericTag,
} from '../../types/components'

interface TagEditorProps {
  tags: GenericTag[],
  value: string[],
  readOnly?: boolean,
  onChange: {
    (value: string[]): void,
  }
}

const DEFAULT_TAGS: GenericTag[] = []
const DEFAULT_VALUE: string[] = []

const TagEditor: FC<TagEditorProps> = ({
  tags,
  value,
  readOnly,
  onChange,
}) => {

  tags = tags || DEFAULT_TAGS
  value = value || DEFAULT_VALUE

  const onTagChange = useCallback((id: string, checked: boolean) => {
    const newValues = value.filter(i => i != id)
    if(checked) newValues.push(id)
    onChange(newValues)
  }, [
    value,
  ])

  return (
    <FormGroup row>
      {
        tags.map((tag) => (
          <TagCheckbox
            key={ tag.id }
            tag={ tag }
            checked={ value.indexOf(tag.id) >= 0 }
            readOnly={ readOnly }
            onChange={ onTagChange }
          />
        ))
      }
    </FormGroup>
  )
}

export default TagEditor